module.exports = __webpack_public_path__ + "static/img/step2-active.db759276.png";